import { Table as MantineTable } from '@mantine/core';
import { forwardRef } from 'react';
import { clx } from './clx';
import classes from './table.module.css';
export const GoodTableTd = forwardRef(({ sticky, children, ...props }, ref) => {
    if (sticky !== undefined) {
        const { placement = 'left', noShadow = false, offset = 0 } = typeof sticky === 'boolean' ? {} : sticky;
        return (<MantineTable.Td ref={ref} pos='sticky' left={placement === 'left' ? offset : undefined} right={placement === 'right' ? offset : undefined} data-placement={placement} {...props} className={clx('stickyTd', !noShadow && 'stickyTd__scrollShadow', classes.tableTd, props.className)} style={{
                zIndex: 2,
                ...props.style,
            }} bg={props.bg ?? 'var(--mantine-color-body)'}>
          {children}
        </MantineTable.Td>);
    }
    return (<MantineTable.Td ref={ref} {...props} className={clx(classes.tableTd, props.className)}>
        {children}
      </MantineTable.Td>);
});
